import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BasePage } from '../../../shared/base.page';
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { DxDataGridComponent } from 'devextreme-angular';
import { UIService } from '../../../shared/services/UIService';


@Component({
    templateUrl: './marketers.page.html',
})

// tslint:disable-next-line:component-class-suffix
export class MarketersPage extends BasePage {

    @ViewChild('grid') grid: DxDataGridComponent;
    @ViewChild('grid2') grid2: DxDataGridComponent;
    items: any[] = [{
        title: 'Coupon Management',
        name: 'coupon',
        icon: 'fa fa-credit-card',
        showOnRow: true
    }];

    // Units: any[] = [
    //     {
    //         title: "Exact Price",
    //         value: 1
    //     }
    //     ,
    //     {
    //         title: "Percent",
    //         value: 2
    //     }
    // ]
     unitEnum:any[] = [{
        "ID": 1,
        "Name": "Exact Price"
    }, {
        "ID": 2,
        "Name": "Percent"
    }];

    popupCouponVisible = false;
    couponList: any[] = [];
    loadingVisible = false;
    loadID: object;
    saveID: object;

    constructor(public router: Router, serviceCaller: ServiceCaller, public uiService: UIService) {
        super(serviceCaller);
    }

    onMenuItemClick(e) {
        switch (e.name) {

            case 'coupon':
                {
                    this.couponManage();
                    this.grid2.instance.refresh();
                    break;
                }
        }
    }

    getID() {
        const list = this.grid.instance.getSelectedRowKeys();
        if (list.length) {
            this.loadID = { id: list[0] };
            this.saveID = { MarketerID: list[0] };
        }
    }

    couponManage() {
        this.getID();
        this.popupCouponVisible = true;
        //     this.couponList = [];
        //     this.loadingVisible = true;
        //     this.api.get("/Coupon/List/Marketer", { id: id }).then(c => {
        //         this.popupCouponVisible = true;
        //         this.couponList = c as any[];
        //     }).catch(() => {
        //     }).then(() => {
        //         this.loadingVisible = false;
        //     });
        // }
    }
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Marketer/marketers.page.ts